<template>
  <div class="vereadores">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary margem-topo"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h1 class="page-header">{{ label }} Vereador</h1>
        <div class="row">
          <div class="col-xs-12">
            <fieldset>
              <!-- Text input-->
              <div :class="['form-group', { 'has-error': errors.has('nome') }]">
                <label
                  :class="[
                    'col-xs-12',
                    'control-label',
                    'primary',
                    { 'is-danger': errors.has('nome') }
                  ]"
                >
                  Nome do vereador
                </label>
                <div class="col-xs-12 col-sm-6 inputGroupContainer">
                  <div class="input-group">
                    <span class="input-group-addon"
                      ><font-awesome-icon
                        :icon="'id-card'"
                        :class="[{ 'is-danger': errors.has('nome') }]"
                      ></font-awesome-icon
                    ></span>
                    <input
                      ref="nome"
                      v-model="model.nome"
                      name="nome"
                      v-validate="'required'"
                      maxlength="80"
                      :class="[
                        'form-control',
                        { 'is-danger': errors.has('nome') }
                      ]"
                      placeholder="Nome do vereador"
                      type="text"
                    />
                    <div
                      :class="[
                        'input-group-addon',
                        { 'is-danger': errors.has('nome') }
                      ]"
                      v-text="80 - model.nome.length"
                    ></div>
                  </div>
                  <small
                    v-if="errors.has('nome')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="nome"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon :icon="'exclamation-triangle'" />
                    {{ errors.first('nome') }}
                  </small>
                </div>
              </div>

              <!-- Button -->
              <div class="form-group">
                <div class="">
                  <button
                    @click="save()"
                    class="btn btn-default"
                    :disabled="carregando"
                  >
                    <font-awesome-icon
                      v-if="carregando"
                      :icon="'spinner'"
                      spin
                    />
                    <font-awesome-icon v-else :icon="'save'" />
                    Salvar
                  </button>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'

export default {
  name: 'vereador-save',
  data() {
    return {
      label: 'Adicionar',
      model: {
        id: '',
        nome: ''
      },
      carregando: false
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    const { id } = this.$route.params
    if (id) {
      this.label = 'Editar'
      this.loadModel(id)
    }
  },
  methods: {
    async loadModel(id) {
      const response = await request.get(`vereador/${id}`)
      this.model = response.data
    },
    toogleLoading() {
      this.carregando = !this.carregando
    },
    saveSuccess() {
      this.$toastr.s('Vereador salvo com sucesso.')
      this.$router.push({ name: 'user_vereadores' })
    },
    saveFail(error) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
      console.log(error.response)
      this.toogleLoading()
    },
    save() {
      this.toogleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          this.toogleLoading()
          return
        }
        if (this.model.codigo) {
          request
            .put(`vereador/${this.model.codigo}`, this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
        } else {
          request
            .post('vereador', this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/vereadores/Save.vue